<template>
  <div class="s-wizard__questions__body">
    <div
      v-for="(question, index) in stepData"
      :key="index"
      class="question-row--two-column">
      <div class="question-wrapper">
        <span class="question-number">
          {{ dictionary.step4QuestionLabel }}
          {{ index + 1 }}
          {{ dictionary.step4QuestionFromLabel }}
          {{ stepData.length }}
        </span>
        <span class="question-text--multiple">
          {{ question.questionTxt }}
        </span>
      </div>
      <div class="question-options--grid">
        <div
          v-for="(item, itemIndex) in question.answers"
          :key="itemIndex"
          class="option"
          :class="{ selected: selectedOptions[index] === item.id }">
          <template v-if="stepData[index].type === 'single'">
            <input
              :id="item.id"
              v-model="selectedOptions[index]"
              type="radio"
              :name="'option' + index"
              :value="item.id"
              @change="selectAnswer(stepData[index].type, index)" />
          </template>
          <template v-if="stepData[index].type === 'multiple'">
            <input
              :id="item.id"
              v-model="selectedOptions[index]"
              type="checkbox"
              :name="'option' + index"
              :value="item.id"
              @change="selectAnswer(stepData[index].type, index)" />
          </template>

          <label :for="item.id" v-html="item.text"></label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'

export default {
  props: {
    stepData: {
      required: true,
      type: Array,
    },
    currentStep: {
      required: true,
      type: Number,
    },
  },
  emits: ['gather-data', 'enable-next-btn'],
  data() {
    return {
      selectedOptions: [],
    }
  },

  computed: {
    // formatedData() {
    // return this.stepData[3].questions[0].answers
    // },
  },
  mounted() {
    const { steps } = lib.getData('wizardDataNew')
    this.steps = steps

    this.$nextTick(() => {
      this.selectedOptions = new Array(this.stepData.length).fill(new Array())
    })
  },

  methods: {
    selectAnswer(type, index) {
      const allNotNull = this.selectedOptions.every(
        (element) => element.length > 0
      )

      if (type === 'single') {
        this.$emit('enable-next-btn')
        if (this.selectedOptions[index].length) {
          this.$emit('gather-data', {
            questionId: this.stepData[index].id,
            answerIds: [this.selectedOptions[index]],
          })
        }
      }

      if (type === 'multiple') {
        this.$emit('enable-next-btn', true)
        if (this.selectedOptions[index].length) {
          this.$emit('gather-data', {
            questionId: this.stepData[index].id,
            answerIds: this.selectedOptions[index],
          })
        }
      }

      if (allNotNull) {
        this.$emit('enable-next-btn', true)
      } else {
        this.$emit('enable-next-btn', false)
      }
    },
  },
}
</script>
